import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import {
  MANAGE_TYPE_OPTIONS,
  MANAGE_SPACE_OPTIONS,
} from "../../../resources/constants/sidebarMenu";

const state = {
  loader: null,
  userPaperPlaneId: 0,
  openPaperPlaneModal: false,
  openUserInfoModal: false,
  userInfoId: 0,
  showUserTechnicalInfo: false,
  wonderPointUrl: "",
  openWonderPointModal: false,
  deviceNotification: null,
  openChangeSpaceModal: false,

  spaceUserTechnicalInfoReceived: {},

  pusher: null,
  graphicClientVersion: "",

  showCompleteOnBoarding: false,
  showWelcome: false,
  suggestionsNotifications: null,

  maintenanceModal: false,
  maintenanceStart: 0,
  maintenaceFinish: 0,
  maintenanceMessageError: false,

  showPhotonErrorModal: false,
  showExitModal: false,

  zoom: 15,
  maxZoom: 100,
  minZoom: 15,
  showCameraOptions: false,

  showTutorialModal: false,
  tutorialText: 1,
  callTimer: 0,
  notificationTutorial: null,
  manageSpaceMenuActive: MANAGE_SPACE_OPTIONS.CUSTOMIZE,
  manageModalType: MANAGE_TYPE_OPTIONS.CAMPUS,

  showConfirmBanModal: false,
  confirmModalData: 0,

  showDescriptionBooth: false,
  descriptionBoothTimeOut: null,
  dataDescriptionBooth: "",
  descriptionBoothCountDown: false,

  showVacation: false,

  showGoodMorningModal: false,

  blockChangeEmoji: false,
  reactions: [],

  showWebGLContextLostModal: false,

  showCloseWebinarModal: false,
  webinarCloseId: 0,

  showCallErrorModal: false,

  selecSuperSpaceId: 0,

  showPinModal: false,
  selectedPinSuperSpaceId: 0,
  pinCountDown: false,
  pinTimeOut: null,

  superSpaceUserPaperPlaneId: 0,

  showPinRoomModal: false,
  isChangePin: false,

  openPosterModal: false,
  poster: null,

  errorGeneralClientGraphic: false,
  errorDataGeneralClientGraphic: "",

  showCallErrorRetryModal: false,

  showBirthdayModal: false,
  dataBirthdayModal: null,

  openChangeSpaceFavouriteModal: false,

  openNotepadButton: false,
  openNotepadModal: false,

  currentRoom: null,
  showCompleteOnBoardingTeams: false,
  
  waitingResponseTimeout: null,

  showRobotModal: false,

  showEducationModal: false,

  showEducationToolModal: false,

  educationBotId: 0,

  openSpotifyModal: false,

  showGameKillerModal: false,

  showGameKillerInfoModal: false,

  showGameKillerVoteAndWinnerModal: false,

  gamekillerWinner: false,

  reserveRoomModal: false,
  
  showCttiGameModal: false,

  showAutoVideoEnterModal: false,

  autoVideo: false,

  reservePhysicalRoomModal: false,

  assistant: null,

  accessTokenGoogle: "",
  accessTokenHotmail: "",

  showModalPlanWarningPremium: false,
};

export type State = typeof state;

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
